import { TimeRange } from '@nf/types/common';
import { cva, VariantProps } from 'class-variance-authority';

const tagVariants = cva('tag', {
	variants: {
		variant: {
			new: 'new-tag',
			pick: 'pick-tag',
		},
	},
	defaultVariants: {
		variant: 'new'
	}
});

function isWithinTimeRange({ from, to }: TimeRange): boolean {
	if (from === undefined && to === undefined) {
		return false;
	}
	
	const currentTime = new Date().getTime();
	const isAlreadyBegin = !from || from <= currentTime;
	const isStillInTheRange = !to || currentTime <= to;
	return isAlreadyBegin && isStillInTheRange;
}

interface NewFeatureBadgeProps extends VariantProps<typeof tagVariants> {
	className?: string;
	text?: string;
	timeRange?: TimeRange;
}

export const NewFeatureBadge = ({
	className,
	text = 'NEW',
	timeRange,
	variant = 'new'
}: NewFeatureBadgeProps) => {
	const isVisible = timeRange === undefined || isWithinTimeRange(timeRange);

	return isVisible ? (
		<div className={tagVariants({ variant, className })}>{text}</div>
	) : null;
};